'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _Reflect$construct = require('@babel/runtime-corejs3/core-js-stable/reflect/construct');
var _createClass = require('@babel/runtime-corejs3/helpers/createClass');
var _classCallCheck = require('@babel/runtime-corejs3/helpers/classCallCheck');
var _possibleConstructorReturn = require('@babel/runtime-corejs3/helpers/possibleConstructorReturn');
var _getPrototypeOf = require('@babel/runtime-corejs3/helpers/getPrototypeOf');
var _inherits = require('@babel/runtime-corejs3/helpers/inherits');
var items_data = require('./items.data.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _Reflect$construct__default = /*#__PURE__*/_interopDefaultLegacy(_Reflect$construct);
var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _possibleConstructorReturn__default = /*#__PURE__*/_interopDefaultLegacy(_possibleConstructorReturn);
var _getPrototypeOf__default = /*#__PURE__*/_interopDefaultLegacy(_getPrototypeOf);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);

function _callSuper(t, o, e) { return o = _getPrototypeOf__default["default"](o), _possibleConstructorReturn__default["default"](t, _isNativeReflectConstruct() ? _Reflect$construct__default["default"](o, e || [], _getPrototypeOf__default["default"](t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(_Reflect$construct__default["default"](Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }

/**
 * Base link object.
 * @preferred
 */
var ItemsDataLink = /*#__PURE__*/function (_ItemsData) {
  /**
   * The unique indentifier of the link
   * @type {string}
   */

  /**
   * id of the source node which is the node where the link originates.
   * @type {string}
   */

  /**
   * id of the target node.
   * @type {string}
   */

  /**
   * Attribute object of the link.
   * @type {Object}
   */

  /**
   * visualization style of the link object.
   * @type {Object}
   */

  /**
   * This filed can be used to provide multiple classes for styling.
   * Such as className = "classA classB classN";
   * @type {string}
   */

  function ItemsDataLink(internalID, sourceID, targetID) {
    var _this;
    _classCallCheck__default["default"](this, ItemsDataLink);
    _this = _callSuper(this, ItemsDataLink);
    _this.id = internalID;
    _this.from = sourceID;
    _this.to = targetID;
    _this.className = '';
    return _this;
  }
  _inherits__default["default"](ItemsDataLink, _ItemsData);
  return _createClass__default["default"](ItemsDataLink);
}(items_data.ItemsData);

exports.ItemsDataLink = ItemsDataLink;
